var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_2826_1242)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2826_1242)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2826_1242)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2826_1242)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2826_1242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 13H14.0937C13.4906 13 13 13.4906 13 14.0937V16.9062C13 17.5094 13.4906 18 14.0937 18H18.7812C19.3844 18 19.875 17.5094 19.875 16.9062V14.0937C19.875 13.4906 19.3844 13 18.7812 13Z",
    fill: "url(#paint1_linear_2826_1242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 19.25H14.0937C13.4906 19.25 13 19.7406 13 20.3438V26.9063C13 27.5094 13.4906 28 14.0937 28H18.7812C19.3844 28 19.875 27.5094 19.875 26.9063V20.3438C19.875 19.7406 19.3844 19.25 18.7812 19.25Z",
    fill: "url(#paint2_linear_2826_1242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9063 23H22.2188C21.6156 23 21.125 23.4906 21.125 24.0938V26.9063C21.125 27.5094 21.6156 28 22.2188 28H26.9063C27.5094 28 28 27.5094 28 26.9063V24.0938C28 23.4906 27.5094 23 26.9063 23Z",
    fill: "url(#paint3_linear_2826_1242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9063 13H22.2188C21.6156 13 21.125 13.4906 21.125 14.0937V20.6562C21.125 21.2594 21.6156 21.75 22.2188 21.75H26.9063C27.5094 21.75 28 21.2594 28 20.6562V14.0937C28 13.4906 27.5094 13 26.9063 13Z",
    fill: "url(#paint4_linear_2826_1242)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2826_1242",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2826_1242",
    x1: 16.4375,
    y1: 17.6279,
    x2: 16.4376,
    y2: 12.8782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4CBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999496,
    stopColor: "#F5ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2826_1242",
    x1: 16.4375,
    y1: 27.3488,
    x2: 16.4379,
    y2: 19.0369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4CBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999496,
    stopColor: "#F5ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2826_1242",
    x1: 24.5625,
    y1: 27.6279,
    x2: 24.5626,
    y2: 22.8782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4CBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999496,
    stopColor: "#F5ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2826_1242",
    x1: 24.5625,
    y1: 21.0988,
    x2: 24.5629,
    y2: 12.7869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4CBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999496,
    stopColor: "#F5ECFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2826_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2826_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2826_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2826_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaDashboardIcon);
export default __webpack_public_path__ + "static/media/SA_DashboardIcon.4035982a41ce1a8ed0f0e3fb60749d6e.svg";
export { ForwardRef as ReactComponent };